__turbopack_context__.v({
  "detaljer": "UnderenhetKortliste-module__GtqAFW__detaljer",
  "kopier": "UnderenhetKortliste-module__GtqAFW__kopier",
  "kort": "UnderenhetKortliste-module__GtqAFW__kort",
  "lenke": "UnderenhetKortliste-module__GtqAFW__lenke",
  "liste": "UnderenhetKortliste-module__GtqAFW__liste",
  "merkelapp": "UnderenhetKortliste-module__GtqAFW__merkelapp",
  "sortering": "UnderenhetKortliste-module__GtqAFW__sortering",
  "visFlere": "UnderenhetKortliste-module__GtqAFW__visFlere",
});
